import { DELETE_REPORTS, ReportsAction, SET_REPORTS } from "../types";

export const setReports = (spaces: any): ReportsAction => {
  return {
    type: SET_REPORTS,
    payload: spaces,
  };
};

export const deleteReports = (): ReportsAction => {
  return {
    type: DELETE_REPORTS,
  };
};
